import { render, staticRenderFns } from "./LecturesStudentsWidget.vue?vue&type=template&id=d9d2fd7e&scoped=true"
import script from "./LecturesStudentsWidget.vue?vue&type=script&lang=js"
export * from "./LecturesStudentsWidget.vue?vue&type=script&lang=js"
import style0 from "./LecturesStudentsWidget.vue?vue&type=style&index=0&id=d9d2fd7e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9d2fd7e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d9d2fd7e')) {
      api.createRecord('d9d2fd7e', component.options)
    } else {
      api.reload('d9d2fd7e', component.options)
    }
    module.hot.accept("./LecturesStudentsWidget.vue?vue&type=template&id=d9d2fd7e&scoped=true", function () {
      api.rerender('d9d2fd7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Widgets/LecturesStudentsWidget.vue"
export default component.exports